<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <activity-info :info="info"></activity-info>
      </div>
    </div>
  </section>
</template>

<script>
import activityInfo from './Temp/ActivityInfo.vue'
export default {
  components: {
    'activity-info': activityInfo
  },
  data () {
    return {
      info: {
        attend_stores: [],
        give_coupons: [],
        strategy_data: {},
        info: {}
      }
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getFile () {
      return this.$parent.getFile
    }
  },
  created () {
    this.getActivity()
  },
  methods: {
    getActivity () {
      var self = this
      var url = 'activity/' + this.$route.params.activity_id + '/orderCouponComplete'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          self.info = response.data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ActivityInfo.vue?ef810a86